import { gql } from 'apollo-angular';

export const GenerateSubscriptionsManagementUrlDocument = gql`
  mutation generateSubscriptionsManagementUrl {
    generateSubscriptionsManagementUrl {
      redirectUrl
    }
  }
`;
